import {createAction} from "@reduxjs/toolkit";
import {ServiceEventSearchCriteria} from "@ots-frontend/ots-data";

export const setUIServiceEventSearchFilter = createAction<ServiceEventSearchCriteria>("ots-ui/service-event/setSearchFilter");
